import styled from 'styled-components';
export const ListInformation = styled.div.withConfig({
  displayName: "DetailInformationstyle__ListInformation",
  componentId: "sc-1xfo6t1-0"
})(["", " span{", "}p{", "}@media (max-width:", "){", "}"], {
  "display": "grid",
  "gridTemplateColumns": "180px auto",
  "justifyContent": "flex-start",
  "gap": "2rem",
  "borderRadius": "0.5rem",
  "padding": "0.5rem",
  "fontSize": "28px",
  "lineHeight": "30px",
  "--tw-text-opacity": "1",
  "color": "rgb(88 88 88 / var(--tw-text-opacity, 1))"
}, {
  "fontWeight": "400"
}, {
  "fontWeight": "500"
}, ({
  theme
}) => theme.breakpoint.md, {
  "display": "grid",
  "gridTemplateColumns": "104px auto",
  "gap": "1rem",
  "fontSize": "24px",
  "lineHeight": "2rem"
});
export const Age = styled.div.withConfig({
  displayName: "DetailInformationstyle__Age",
  componentId: "sc-1xfo6t1-1"
})(["", " p{", "}@media (max-width:", "){", " p{", "}}"], {
  "width": "11rem"
}, {
  "fontSize": "1.5rem",
  "lineHeight": "30px",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(167 167 167 / var(--tw-text-opacity, 1))"
}, ({
  theme
}) => theme.breakpoint.md, {
  "width": "7rem"
}, {
  "fontSize": "1rem",
  "lineHeight": "1.5rem"
});
export const ListItem = styled.div.withConfig({
  displayName: "DetailInformationstyle__ListItem",
  componentId: "sc-1xfo6t1-2"
})(["", " img{", "}"], {
  "alignItems": "center"
}, {
  "marginLeft": "0.25rem",
  "display": "inline",
  "aspectRatio": "1 / 1",
  "width": "1.5rem"
});